import React from 'react'
import Card from '@components/V3/Card'

export default function Skeleton() {
  return (
    <Card className="max-w-[1024px] w-full">
      <div className="px-4 pt-6">
        <div className="flex flex-col space-y-2 animate-pulse">
          <div className="h-4 sm:h-6 w-2/5 bg-gray-200 dark:bg-zinc-600 rounded mx-auto sm:mx-0"></div>
          <div className="h-2"></div>
          <div className="h-3 sm:h-4 w-full bg-gray-200 dark:bg-zinc-600 rounded"></div>
          <div className="h-3 sm:h-4 w-full bg-gray-200 dark:bg-zinc-600 rounded sm:hidden"></div>
          <div className="h-3 sm:h-4 w-full bg-gray-200 dark:bg-zinc-600 rounded sm:hidden"></div>
          <div className="h-4"></div>
          <div className="flex flex-col space-y-2">
            <div className="h-4 w-1/6 bg-gray-200 dark:bg-zinc-600 rounded"></div>
            <div className="h-11 bg-gray-200 dark:bg-zinc-600 rounded"></div>
          </div>
          <div className="w-full h-12 bg-gray-200 dark:bg-zinc-600 rounded"></div>
        </div>
      </div>
    </Card>
  )
}
